export default __webpack_public_path__ + "static/blackFridayBanner-c492cc10af9776d8e13ded84bfdbb887.png";